import { Breadcrumb } from "react-bootstrap";

interface NavProps {
  title: string;
  route: string;
  active: string;
}

const NavSettings: React.FC<NavProps> = ({ title, route, active }) => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <h3 className="mb-0">{title}</h3>

        <Breadcrumb className="breadcrumb-page-list align-items-center mb-0 lh-1">
          <Breadcrumb.Item href="/store">
            <div className="d-flex align-items-center text-decoration-none">
              <i className="ri-home-4-line fs-18 text-primary me-1"></i>
              <span className="text-secondary fw-medium hover">{route}</span>
            </div>
          </Breadcrumb.Item>

          <Breadcrumb.Item active>
            <span className="fw-medium">{active}</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
    </>
  );
};

export default NavSettings;
